import { z } from 'zod';

export const salesReportExportParametersSchema = z
	.strictObject({
		kind: z.enum(['report', 'fee', 'billback', 'payment']),
		filters: z
			.array(
				z.strictObject({
					propertyName: z.string().min(1),
					op: z.enum([
						'contains',
						'startsWith',
						'endsWith',
						'equals',
						'not',
						'notEquals',
						'gt',
						'gte',
						'lt',
						'lte',
						'isEmpty',
						'isNotEmpty',
						'isAnyOf',
						'in',
					]),
					value: z
						.union([z.string(), z.number(), z.array(z.union([z.string(), z.number()])), z.null()])
						.optional(),
				}),
			)
			.default([]),
		order: z
			.strictObject({ field: z.string().min(1), sort: z.enum(['asc', 'desc']) })
			.default({ field: 'reportDate', sort: 'desc' }),
		drStatus: z.array(z.enum(['DRAFT', 'PENDING', 'POSTED', 'PENDING_REVERSAL', 'REVERSED'])).optional(),
		selectedTimezone: z
			.string()
			.refine((zone) => {
				try {
					new Intl.DateTimeFormat('en-US', { timeZone: zone });
					return true;
				} catch {
					return false;
				}
			}, 'Invalid timezone')
			.default('America/Chicago'),
	})
	.superRefine((value, context) => {
		if (value.kind === 'report' && !value.drStatus?.length) {
			context.addIssue({ code: 'custom', path: ['drStatus'], message: 'Daily report statuses are required' });
		}
	});

export type SalesReportExportParameters = z.infer<typeof salesReportExportParametersSchema>;
